import React, { useState } from 'react';
import { Grid } from "@material-ui/core";
import TextFieldPesquisa from "../../../shared/components/TextFieldPesquisa";
import TextFieldBarCode from "../../../shared/components/TextFieldBarCode";
import useDebounce from "../../../shared/customHooks/useDebounce";

const FiltrosAmostrasNoLote = ({
    filtros,
    handleChangeFiltros,
    codigoAmostra,
    handleChangeCodigoAmostra,
    handleEnterDown,
    carregando,
    codigoAmostraRef,
    ehLoteKPA
}) => {
    const [buscaLocal, setBuscaLocal] = useState(filtros.busca || "");
    const handleChangeBuscaDebouce = useDebounce(handleChangeFiltros, 600);
    
    const handleChangeBuscaLocal = (event) => {
        const novaBusca = event.target.value;
        setBuscaLocal(novaBusca);

        if (novaBusca.length > 2 || novaBusca.length === 0){
            handleChangeBuscaDebouce({...filtros, busca: novaBusca});
        }
    }

    return (
        <Grid container spacing={3}>
            <Grid item xs={6}>
                <TextFieldBarCode
                    autoFocusEnable={true}
                    label="Incluir amostra com leitor ou manualmente"
                    value={codigoAmostra}
                    onChange={handleChangeCodigoAmostra}
                    loading={carregando}
                    inputRef={codigoAmostraRef}
                    handleIconButton={handleEnterDown}
                    possuiMascara={!ehLoteKPA}
                />
            </Grid>

            <Grid item xs={6}>
                <TextFieldPesquisa
                    id="buscarAmostras"
                    label="Buscar por amostra, paciente, pedido ou tipo"
                    value={buscaLocal}
                    onChange={handleChangeBuscaLocal}
                    iconeSeparador={true}
                />
            </Grid>
        </Grid>
    );
}

export default FiltrosAmostrasNoLote;